import { Screen } from "../../../main/components/screen/Screen";
import OperationalScreen from "../components/centerOperationsCards/OperationalScreen";
import TacticalScreen from "../components/centerOperationsCards/TacticalScreen";
import StrategicScreen from "../components/centerOperationsCards/StrategicScreen";
import { useClientClusterUsinaFilterContext } from "../../../main/context/ClientClusterUsinaFilterContextProvider";
export { CenterScreensEnum, type CenterScreenValue } from "../centerScreensEnum";
import { CenterScreensEnum } from "../centerScreensEnum";

export default function CenterOperations() {
    const { selectedScreen } = useClientClusterUsinaFilterContext();

    return (
        <Screen.Root>
            {selectedScreen === CenterScreensEnum.Tactical && <TacticalScreen />}
            {selectedScreen === CenterScreensEnum.Strategic && <StrategicScreen />}
            {selectedScreen === CenterScreensEnum.Operational && <OperationalScreen />}
        </Screen.Root>
    )
}